import { fromJS } from 'immutable'
import {
  TIMESHEET_SUBMIT_REQUEST,
  TIMESHEET_SUBMIT_SUCCESS,
  TIMESHEET_SUBMIT_FAILURE,
  TIMESHEET_SUBMIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TIMESHEET_SUBMIT_REQUEST:
      return state
        .set('isFetching', true)
    case TIMESHEET_SUBMIT_SUCCESS:
      return state
        .set('submittedTimesheet', fromJS(action.payload))
        .set('status', 200)
        .set('message', 'Submitted Successfully.')
        .set('isFetching', false)
    case TIMESHEET_SUBMIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('submittedTimesheet', fromJS(action.payload))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case TIMESHEET_SUBMIT_RESET:
      return state
        .delete('submittedTimesheet')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheet/timesheet-submit-reducer.js